// extracted by mini-css-extract-plugin
export default {"copyCode":"index-module__rhqiv","embedBox":"index-module__FFNBi","copySpan":"index-module__o56tR","embedCopy":"index-module__S2IkL","embedCopyBox":"index-module__Dgjp6"};